import {
  CustodianTypes,
  DefaultUserManagersResponse,
  UserManagerInfo,
} from 'services/requests';

export const checkDefaultUserManager = (
  data: DefaultUserManagersResponse,
  custodianType: string | number | undefined,
): UserManagerInfo => {
  if (custodianType === CustodianTypes.iraClub && data.iraClub) {
    return data.iraClub;
  }
  if (custodianType === CustodianTypes.solera && data.solera) {
    return data.solera;
  }
  if (custodianType === CustodianTypes.madisonTrust && data.madisonTrust) {
    return data.madisonTrust;
  }
  if (custodianType === CustodianTypes.advantaIra && data.advantaIra) {
    return data.advantaIra;
  }
  if (custodianType === CustodianTypes.entrust && data.entrust) {
    return data.entrust;
  }
  if (custodianType === CustodianTypes.forgeTrust && data.forgeTrust) {
    return data.forgeTrust;
  }
  if (custodianType === CustodianTypes.iPlanGroup && data.iPlanGroup) {
    return data.iPlanGroup;
  }
  if (custodianType === CustodianTypes.cnbCustody && data.cnbCustody) {
    return data.cnbCustody;
  }
  if (custodianType === CustodianTypes.inspira && data.inspira) {
    return data.inspira;
  }
  if (custodianType === CustodianTypes.mountainWestIra && data.mountainWestIra) {
    return data.mountainWestIra;
  }
  if (custodianType === CustodianTypes.midAtlanticIra && data.midAtlanticIra) {
    return data.midAtlanticIra;
  }
  if (custodianType === CustodianTypes.horizonTrust && data.horizonTrust) {
    return data.horizonTrust;
  }
  if (custodianType === CustodianTypes.nextGenTrust && data.nextGenTrust) {
    return data.nextGenTrust;
  }
  if (custodianType === CustodianTypes.camaPlan && data.camaPlan) {
    return data.camaPlan;
  }

  return null;
};
